

















































import { Component, Vue } from 'vue-property-decorator';
import faker from 'faker';
import AuthModule from '@/store/AuthModule';
import {
    getInvoicesPrescriber,
    getInvoiceDownloadPdfPrescriber,
} from '@/api/api';
import Invoice from '@/models/Invoice';
import get from 'lodash/get';
import SubscriptionPrescriber from '@/models/SubscriptionPrescriber';
import last from 'lodash/last';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { BACKEND_URL } from '@/helpers/constants';


@Component({
    filters: {
        euro: function(value: number) {
            return new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
            }).format(value);
        },
        formatDate: (value: string) => {
            return value ? moment(value).format('L') : null;
        },
        HT: function(value: number) {
            return new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
            }).format(value / 1.2);
        },
    },
})
export default class SubscriptionPrescriberComponent extends Vue {
    invoices: Invoice[] = [];
    BACKEND_URL = BACKEND_URL;

    async created() {
        const resp = await getInvoicesPrescriber();
        this.invoices = resp.data;
        //console.log('invoices', this.invoices);
    }

    downloadInvoice(invoiceId: number) {
        const $vs = (this as any).$vs;
        getInvoiceDownloadPdfPrescriber(invoiceId)
            .then((resp: any) => {
                console.log('resp', resp);
                const fileName = resp.headers['content-disposition'].split(
                    '"'
                )[1];
                console.log('fileName', fileName);
                try {
                    saveAs(resp.data, fileName);
                } catch (e) {
                    console.log('error', e);
                }
            })
            .catch(() => {
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text:
                        'Une erreur est survenue lors de la récupération du pdf',
                });
            });
    }
}
